<template>
  <div class="md:flex py-2 flex-wrap justify-between bg-smoke-100 lg:py-10 lg:flex-no-wrap lg:justify-evenly shadow-md">
    <div class="flex md:w-1/2 p-4 lg:w-auto lg:p-0  md:mb-0">
      <div style="min-width: 55px" class="flex justify-center flex-row"><img src="@/assets/images/sku.png" class="w-9 h-13"></div>
      <div class="pl-2 lg:pl-2 xl:pl-4 md:max-w-70">
        <div class="text-3xl pt-1 leading-6">
          <span id="BHSKU">500</span>+
        </div>
        <div class="text-sub-text text-base">
          SKUs from vetted manufacturers
        </div>
      </div>
      <!-- <div class="hidden lg:block border-l-2 border-gray-400 ml-10 mr-5 h-content"></div> -->
    </div>
    <div class="flex md:w-1/2 p-4 lg:w-auto lg:p-0 md:mb-0 lg:px-16 lg:border-l-2 lg:border-r-2 border-gray-400">
      <div style="min-width: 55px" class="flex justify-center flex-row"><img src="@/assets/images/users.png" class="w-13 h-13"></div>
      <div class="pl-2 lg:pl-2 xl:pl-4 md:max-w-75">
        <div class="text-3xl pt-1 leading-6">
          <span id="BHUsers">97,000</span>+
        </div>
        <div class="text-sub-text text-base">Users on BuyHive</div>
      </div>
      <!-- <div class="hidden lg:block border-l-2 border-gray-400 ml-10 mr-5 h-content"></div> -->
    </div>
    <div class="flex md:w-1/2 p-4 lg:w-auto lg:p-0  md:mb-0">
      <div style="min-width: 55px" class="flex justify-center flex-row"><img src="@/assets/images/transactions.png" class="w-11 h-13"></div>
      <div class="pl-2 lg:pl-2 xl:pl-4 md:max-w-70">
        <div class=" text-3xl pt-1 leading-6">
          USD <span id="BHTransactions">18,500,000</span>+
        </div>
        <div class="text-sub-text text-base">
          Transaction value on BuyHive
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TickerSection',
  methods:{
    animateValue(id, start, end, duration) {
      let obj = document.getElementById(id);
      let range = end - start;
      let minTimer = 50;
      let stepTime = Math.abs(Math.floor(duration / range));
      stepTime = Math.max(stepTime, minTimer);
      let startTime = new Date().getTime();
      let endTime = startTime + duration;
      let timer;
    
      function run() {
          let now = new Date().getTime();
          let remaining = Math.max((endTime - now) / duration, 0);
          let value = Math.round(end - (remaining * range));
          obj.innerHTML = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          if (value == end) {
              clearInterval(timer);
          }
      }
      timer = setInterval(run, stepTime);
      run();
    }
  },
  mounted () {
    this.animateValue("BHSKU", 0, 500, 2500);
    this.animateValue("BHUsers", 0, 97000, 2500);
    this.animateValue("BHTransactions", 0, 18500000, 2500);
  }
}
</script>